export const 기계적요인 = [
  {
    id: 1,
    label: "협착 위험(감김, 끼임)",
    is_checked: "",
    note: "",
  },
  {
    id: 2,
    label: "위험한 표면(절단, 베임, 긁힘)",
    is_checked: "",
    note: "",
  },
  {
    id: 3,
    label: "기계(설비)의 낙하, 비래, 전복, 붕괴, 전도 위험",
    is_checked: "",
    note: "",
  },
  {
    id: 4,
    label: "충돌 위험",
    is_checked: "",
    note: "",
  },
  {
    id: 5,
    label: "넘어짐 위험(미끄러짐, 걸림, 헛디딤)",
    is_checked: "",
    note: "",
  },
  {
    id: 6,
    label: "추락 위험",
    is_checked: "",
    note: "",
  },
];

export const 전기적요인 = [
  {
    id: 1,
    label: "감전",
    is_checked: "",
    note: "",
  },
  {
    id: 2,
    label: "전기불꽃",
    is_checked: "",
    note: "",
  },
  {
    id: 3,
    label: "화재폭발",
    is_checked: "",
    note: "",
  },
];
export const 화학적요인 = [
  {
    id: 1,
    label: "기체: 가스, 증기 등",
    is_checked: "",
    note: "",
  },
  {
    id: 2,
    label: "액체: 미스트, 에어로졸 등",
    is_checked: "",
    note: "",
  },
  {
    id: 3,
    label: "고체: 흄, 분진 등",
    is_checked: "",
    note: "",
  },
];
export const 생물학적요인 = [
  {
    id: 1,
    label: "병원성 미생물, 바이러스 등",
    is_checked: "",
    note: "",
  },
  {
    id: 2,
    label: "유전자 변형물질",
    is_checked: "",
    note: "",
  },
  {
    id: 4,
    label: "동물, 식물",
    is_checked: "",
    note: "",
  },
];
export const 작업특성요인 = [
  {
    id: 1,
    label: "소음, 진동",
    is_checked: "",
    note: "",
  },
  {
    id: 2,
    label: "종사자 실수(휴먼 에러)",
    is_checked: "",
    note: "",
  },
  {
    id: 3,
    label: "이상기압 및 밀폐공간",
    is_checked: "",
    note: "",
  },
  {
    id: 4,
    label: "중랑물 취급 작업, 반복 작업",
    is_checked: "",
    note: "",
  },
  {
    id: 5,
    label: "불안정한 작업 자세, 작업(조작) 도구",
    is_checked: "",
    note: "",
  },
];
export const 작업환경요인 = [
  {
    id: 1,
    label: "이상기온",
    is_checked: "",
    note: "",
  },
  {
    id: 2,
    label: "조명, 공간 및 이동통로",
    is_checked: "",
    note: "",
  },
  {
    id: 3,
    label: "주변 종사자, 작업 시간",
    is_checked: "",
    note: "",
  },
  {
    id: 4,
    label: "화상",
    is_checked: "",
    note: "",
  },
  {
    id: 5,
    label: "작업(조작) 도구",
    is_checked: "",
    note: "",
  },
];
